import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .controller(
    'schedulePreferencesController',
    function schedulePreferencesController(
      $scope: angular.IScope,
      $state: any,
      $stateParams: ng.ui.IStateParamsService,
      $anchorScroll: any,
      preferencesUpdateModel: any,
      getDayEnums: any,
      $location: any,
      preferencesBusyTimes: any,
      PreferenceTypeEnum: any,
      preferencesCampuses: any
    ) {
      'use strict';

      $scope.termId = $stateParams.termId;
      $scope.isOpened = true;

      const closePreferences = () => {
        $scope.isOpened = false;
        $state.__goToPrevious__();
      };

      $scope.__onClosed = () => {
        closePreferences();
      };

      $scope.currentPreference = PreferenceTypeEnum.CAMPUS_LOCATION.value.id;
      $scope.togglePreference = (preferenceName: any) => {
        $scope.currentPreference = _4.isEqual($scope.currentPreference, preferenceName) ? '' : preferenceName;
      };

      $scope.includeWeekends = '';
      $scope.microheaders = '';
      $scope.enums = getDayEnums();

      $scope.getBusyTimesSummary = () => {
        preferencesBusyTimes.getSummary();
      };

      const isValidList: any = [];
      const notifySubscribers = () => {
        let errorLocation = '';
        _4.each(isValidList, (isValidItem: any) => {
          $scope.$broadcast(isValidItem.id + 'DisplayError', !isValidItem.status);
          if (!isValidItem.status && errorLocation === '') {
            errorLocation = isValidItem.id + '-validation-error';
          }
        });
        if ($location.hash() !== errorLocation && errorLocation !== '') {
          $location.hash(errorLocation);
        } else if (errorLocation !== '') {
          $anchorScroll();
        }
      };

      $scope.$on('isValid', (e: any, val: any) => {
        e.stopPropagation();
        const foundValue = _4.find(isValidList, (isValidItem: any) => {
          return isValidItem.id === val.id;
        });
        if (!_4.isUndefined(foundValue)) {
          foundValue.status = val.status;
        } else {
          isValidList.push(val);
        }
        notifySubscribers();
      });
    }
  )
  .directive('preferencesHasChanged', (preferencesUpdateModel) => {
    return {
      restrict: 'A',
      replace: false,
      scope: false,
      link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
        element.on('mouseup', () => {
          if (preferencesUpdateModel) {
            preferencesUpdateModel.hasUpdated(attrs.preferencesHasChanged);
          }
        });
      }
    };
  })
  .factory('preferencesUpdateModel', () => {
    return {
      _updated: {
        availability: false,
        timeSpent: false,
        campuses: false
      },
      clear() {
        this._updated = {
          availability: false,
          timeSpent: false,
          campuses: false
        };
      },
      hasUpdated(key: any) {
        this._updated[key] = true;
      },
      status(key: any) {
        return this._updated[key];
      }
    };
  })
  .directive(
    'schedulePreferences',
    function schedulePreferences(
      DelegateResponder: any,
      schedulePreferencesExternal: any,
      PreferenceTypeEnum: any,
      calendarPreferencesSyncDelegate: any,
      preferencesCampuses: any,
      preferencesBusyTimes: any
    ) {
      return {
        restrict: 'E',
        replace: true,
        templateUrl: 'capability-ng-scheduler/src/views/components/preferences/preferences.html',
        controller: 'schedulePreferencesController',
        link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
          scope.isSliderOpen = false;
          scope.isFirstTimePreferences = false;

          scope.isFirstTimePref = () => {
            scope.isFirstTimePreferences = true;
          };

          const activate = (scope.activate = () => {
            scope.isSliderOpen = true;
          });

          const deactivate = (scope.deactivate = () => {
            scope.isSliderOpen = false;
          });

          scope.currentPreference = PreferenceTypeEnum.CAMPUS_LOCATION.value.id;
          const togglePreference = (scope.togglePreference = (preferenceName: any) => {
            scope.currentPreference = _4.isEqual(scope.currentPreference, preferenceName) ? '' : preferenceName;
          });

          const toggle = (scope.toggleSlider = () => {
            calendarPreferencesSyncDelegate.exec();
            preferencesCampuses.getSummary();
            preferencesBusyTimes.getSummary();
            if (scope.isSliderOpen) {
              schedulePreferencesExternal.returnToOpenCourse();
            } else {
              activate();
            }
          });

          scope.$on('$destroy', (event) => {
            toggle();
          });

          toggle();

          DelegateResponder(scope, attrs, {
            uniqueComponent: 'scheduler-preferences',
            vocabulary: {
              activate() {
                activate();
              },
              deactivate() {
                deactivate();
              },
              toggle() {
                toggle();
              },
              activate_busytime() {
                togglePreference('busy_time');
              },
              activate_campuses() {
                togglePreference('campus_location');
              }
            }
          });
        },
        scope: {}
      };
    }
  )
  .service(
    'schedulePreferencesDelegate',
    function schedulePreferencesDelegate(this: any, $rootScope: any, DelegateController: any) {
      DelegateController(this, {
        uniqueComponent: 'scheduler-preferences',
        vocabulary: {
          activate: 'active',
          deactivate: 'inactive',
          toggle: 'toggle',
          activate_campuses: 'activate_campuses',
          activate_busytime: 'activate_busytime'
        }
      });
    }
  )
  .service(
    'schedulePreferencesExternal',
    function schedulePreferencesExternal(
      this: any,
      $state: ng.ui.IStateService,
      $timeout: ng.ITimeoutService,
      schedulePreferencesDelegate: any
    ) {
      this.reset = () => {
        this.isCourseInfo = false;
        this.stateWhenOpeningPrefs = '';
        this.params = {};
        this.params.courseId = '';
        this.params.sectionsFilter = '';
      };

      this.reset();

      this.openPreferences = () => {
        const isCourseInfo = $state.is('my.schedule.registration.courseSections');

        if (isCourseInfo) {
          this.stateWhenOpeningPrefs = $state.current.name;
          this.params.courseId = $state.params.courseId;
          this.params.sectionsFilter = $state.params.sectionsFilter;
          $state.go('my.schedule.registration').then(() => {
            $timeout(() => {
              schedulePreferencesDelegate.toggle();
            }, 500);
          });
        } else {
          schedulePreferencesDelegate.toggle();
        }
      };

      this.returnToOpenCourse = (callback: () => void) => {
        const isThereAStateToGoBack = this.stateWhenOpeningPrefs !== '';
        const areParamsSet = !_4.isEmpty(this.params.courseId) && !_4.isEmpty(this.params.sectionsFilter);

        if (isThereAStateToGoBack && areParamsSet) {
          $state.go(this.stateWhenOpeningPrefs, this.params).then(() => {
            this.reset();
            schedulePreferencesDelegate.deactivate();
          });
        } else {
          schedulePreferencesDelegate.deactivate();
        }
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/preferences.ts